import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const HeaderMobileContent = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.w};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 16px;
  `}
`

export const BrandContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const MerchantName = styled.p`
  ${({ theme }) => css(theme.typographys.small.bold)};
  color: ${({ theme }) => theme.colors.neutrals.b};
`

export const CloseContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ theme }) => css(theme.typographys.small.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
  cursor: pointer;
`

export const IconArrow = styled.img`
  transform: rotate(180deg);
`
